import React, { useState, useEffect } from "react";
import { updateCustomer, getCustomerById } from "../../services";

const CustomerCreate = (props) => {
  const [firstName, setFirstName] = useState(""); // Firstname of customer contact
  const [lastName, setLastName] = useState(""); // Lastname of customer contact
  const [fullName, setFullName] = useState(""); // Fullname of customer contact
  const [name, setName] = useState(""); // Customer name
  const [address, setAddress] = useState(""); // Customer Address
  const [city, setCity] = useState(""); // Customer city
  const [postal, setPostal] = useState(""); // Customer postal/zipcode
  const [phone, setPhone] = useState(""); // Customer phone
  const [email, setEmail] = useState(""); // Customer email

  useEffect(() => {
    getCustomerById(props.customerId).then(res => {
      setFullName(res.contact)
      setName(res.name)
      setAddress(res.address)
      setPostal(res.postal)
      setEmail(res.email)
      setPhone(res.phone)
      setCity(res.city)
    })
  },[])

  const submitCustomer = () => {
    updateCustomer(fullName, name, address, city, postal, email, phone, props.customerId).then((res) => {
      props.next();
    });
  };

  return (
    <div className="form__container__content">
      <div className="form__container__content__category">
        <span>Zorginstelling</span>
      </div>
      <div className="form__fields">
        <div className="form__fields__field">
          <span className="form__fields__field__label">Klantnaam</span>
          <input
            required="true"
            value={name}
            onChange={(e) => setName(e.target.value)}
            type="text"
            className="form__fields__field__input"
          />
        </div>
        <div className="form__fields__field">
          <span className="form__fields__field__label">Adres</span>
          <input
            required="true"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            type="text"
            className="form__fields__field__input"
          />
        </div>
        <div className="form__fields__field">
          <span className="form__fields__field__label">Postcode</span>
          <input
            required="true"
            value={postal}
            onChange={(e) => setPostal(e.target.value)}
            type="text"
            className="form__fields__field__input"
          />
        </div>
        <div className="form__fields__field">
          <span className="form__fields__field__label">Plaats</span>
          <input
            required="true"
            value={city}
            onChange={(e) => setCity(e.target.value)}
            type="text"
            className="form__fields__field__input"
          />
        </div>
      </div>
      <div className="form__container__content__category">
        <span>Contactgegevens</span>
      </div>
      <div className="form__fields">
        <div className="form__fields__field">
          <span className="form__fields__field__label">
            Naam
          </span>
          <input
            required="true"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            type="text"
            className="form__fields__field__input"
          />
        </div>
        {/* <div className="form__fields__field">
          <span className="form__fields__field__label">
            Achternaam
          </span>
          <input
            required="true"
            onChange={(e) => setLastName(e.target.value)}
            type="text"
            className="form__fields__field__input"
          />
        </div> */}
        <div className="form__fields__field">
          <span className="form__fields__field__label">
            E-mailadres
          </span>
          <input
            value={email}
            required="true"
            onChange={(e) => setEmail(e.target.value)}
            type="text"
            className="form__fields__field__input"
          />
        </div>
        <div className="form__fields__field">
          <span className="form__fields__field__label">
            Telefoonnummer
          </span>
          <input
            value={phone}
            required="true"
            onChange={(e) => setPhone(e.target.value)}
            type="text"
            className="form__fields__field__input"
          />
        </div>
      </div>
      <button
        className="form__container__content__button"
        onClick={() => submitCustomer()}
      >
        OPSLAAN <i className="fas fa-arrow-right"></i>
      </button>
    </div>
  );
};

export default CustomerCreate;
